import React, { Component } from 'react'
import { extendObservable, computed } from 'mobx'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'
import './EmployeeInitials.sass'

import Tooltip from '@components/Tooltip/Tooltip'
import Avatar from '@components/Avatar'

class EmployeeInitials extends Component {
  constructor (props) {
    super(props)
    extendObservable(this, {
      employee: props.employee,
      initials: computed(() => this.buildInitials(this.employee)),
      employeeData: null,
      fetching: false
    })
  }

  buildInitials (employee) {
    if (employee && employee.firstName && employee.lastName) {
      return employee.firstName[0] + employee.lastName[0]
    }
  }

  fetchData = () => {
    if (this.fetching) return
    this.fetching = true
    this.props.employeeStore.getInitialsData(this.employee.id).then(res => {
      this.employeeData = res
      this.fetching = false
    })
  }

  tooltipContent = () => {
    return (
      <div className="employee-intials-details-container">
        <Avatar
          alt={this.employeeData.fullName}
          className="employee-initials-img"
          src={this.employeeData.pictureUrl}
        />
        <div>
          <div>
            <strong>{this.employeeData.fullName}</strong>
          </div>
          <div>
            {this.employeeData.position}, {this.employeeData.atheneumOffice}
          </div>
        </div>
      </div>
    )
  }

  showTooltip = () => {
    return this.employeeData ? (
      <div>{this.tooltipContent()}</div>
    ) : (
      <div>TooltipText</div>
    )
  }

  render () {
    const className = `employee-initials ${this.props.small ? 'small' : ''}`
    return (
      <div className={className}>
        <Tooltip tooltip={this.showTooltip()}>
          <div
            onMouseEnter={this.fetchData}
            className="employee-initials-badge">
            <span>{this.initials}</span>
          </div>
        </Tooltip>
      </div>
    )
  }
}

EmployeeInitials.propTypes = {
  small: PropTypes.bool,
  employee: PropTypes.object.isRequired,
  employeeStore: PropTypes.object
}

export default inject('employeeStore')(observer(EmployeeInitials))
